var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 43 34"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.625 33.25.375 16.028l4.547-4.646 11.617 12.144L37.898.75l4.727 4.56-26 27.94Z"
  })));
};
export default SvgCheck;